<script>
	import request from './request.vue';

	const schema = [
		// {
		// 	name: "id",
		// 	displayName: "Código",
		// 	kind: "text",
		// 	validation: "",
		// 	placeholder: "Digite o código da categoria",
		// 	defaultSort: true,
		// 	readOnly: true,
		// 	search: {
		// 		show: false,
		// 		endWildcard: true,
		// 		startWildcard: true,
		// 	},
		// },
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome do manual",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "description",
			displayName: "Descrição",
			kind: "long-text",
			validation: "",
			placeholder: "Digite a descrição do manual",
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "manualUrl",
			displayName: "Manual",
			kind: "file-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("manual", `uploadManual/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "thumbnailUrl",
			displayName: "Miniatura",
			kind: "picture-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("manual", `uploadThumbnail/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "iconUrl",
			displayName: "Ícone",
			kind: "picture-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("manual", `uploadIcon/${id}`, formData);
				return response.data;
			},
		},
	];

	export default {
		getSchema: function() {
			return schema;
		},
		create: async function (entity) {
			const response = await request.send("manual", "create", entity, true);
			return response.data;
		},
		read: async function (id) {
			const response = await request.send("manual", "read", { id }, true);
			return response.data;
		},
		update: async function (entity) {
			delete entity.manualUrl;
			delete entity.thumbnailUrl;

			let response = await request.send("manual", "update", entity, true);
			return response.data;
		},
		delete: async function (id) {
			return request.send("manual", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("manual", "search", parameters, true);
		},
	}
</script>
